// extracted by mini-css-extract-plugin
module.exports = {"title":"Room_title__Uln60","roomContainer":"Room_roomContainer__2QmTx","roomMask":"Room_roomMask__FIirK","hr":"Room_hr__2I8UY"};